import { useContext } from "react";
import { NotificationContext } from "./NotificacionProvider";

export const useNotifications = () => {
  return useContext(NotificationContext);
};